import { useClerk } from '@clerk/clerk-react';
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
  Stack,
} from '@mui/material';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import { useUserContext } from '../hooks/useUserContext';
import { setAuthToken } from '../services/api';

export default function TenantInactive() {
  const { signOut } = useClerk();
  const { tenantAccessMessage } = useUserContext();

  const handleSignOut = async () => {
    setAuthToken(null);
    await signOut({ redirectUrl: '/auth/login' });
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'grey.50',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        py: { xs: 6, sm: 12 },
        px: { xs: 2, sm: 6, lg: 8 },
      }}
    >
      <Container maxWidth="sm">
        <Paper
          sx={{
            py: 8,
            px: { xs: 4, sm: 8 },
            textAlign: 'center',
          }}
          elevation={2}
        >
          <PauseCircleIcon
            sx={{
              fontSize: 80,
              color: 'warning.main',
              mb: 2,
            }}
          />

          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Organization Access Paused
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            {tenantAccessMessage ||
              "Your organization's account is currently inactive. Please contact your administrator."}
          </Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
            <Button variant="contained" color="primary" size="large" onClick={() => window.location.reload()}>
              Check Again
            </Button>
            <Button variant="outlined" color="primary" size="large" onClick={() => void handleSignOut()}>
              Sign Out
            </Button>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
}
